import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { DOCUMENT_TYPE_FORMS_AGREEMENTS, DOCUMENT_TYPE_NOTICES_LETTERS, DOCUMENT_TYPE_SURETY_BONDS, individualFileSizeAllowedInMB } from "../../../../../app/constants";
import { ERROR_STRING, VALIDATION_ERROR } from "../../../../../app/errors";
import { acceptedFileFormats, fileTypeEnum, extractBase64  } from "../../../../../app/documentUploadUtils";
import { Button, ErrorWithString, LineSeperator } from "../../../../../components/RegularComponents";
import { saveBusinessLicenceApplicationData } from "../../../../../redux/slice/businessLicenceApplicationSlice";
import { setAgencySupportingDocuments } from "../../../../../redux/slice/primaryAgencyApplicationSlice";


const MAX_FILENAME_LENGTH = 128
const NOT_ALLOWED_CHARS = ["<", ">", ":", "\\", "\"", "/", "\\\\", "|", "?", "*"]

export const AttachmentFileUpload = (props) => {
    const { licenceApplication, applicationType, applicationMode } = props
    const dispatch = useDispatch()
    const [showValidationError/*, setShowValidationError*/] = useState(false)
    const [formsValidationError/*, setFormsValidationError*/] = useState(VALIDATION_ERROR.NO_ERROR)
    const [formsFile, setFormsFile] = useState()

    const [documentType, setDocumentType] = useState(DOCUMENT_TYPE_FORMS_AGREEMENTS)
    const isFormsValid = () => {
        if (showValidationError) {
            return (formsValidationError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const fileSizeReplacement = (string, fileSize) => {
        const replaceRegExp = /<file_size>/g
        const errorString = string.replace(replaceRegExp, (fileSize + "MB"))
        console.error(errorString)
        return errorString
    }

    const validateFileName = (filename) => {
        return !NOT_ALLOWED_CHARS.some(c => {

            if (filename.indexOf(c) !== -1) {
                return true
            }

            return false
        })
    }

    const fileNameWithLengthLimit = (filename) => {
        if (filename.length > MAX_FILENAME_LENGTH) {
            let fileNameComponents = filename.split(".")

            // reduce the name part and then append the extension again.
            if (fileNameComponents.length === 2) {
                let tName = fileNameComponents[0].substring(0, (MAX_FILENAME_LENGTH - (fileNameComponents[1].length + 1)))
                return `${tName}.${fileNameComponents[1]}`
            } else {
                // if there are more than one '.' in the file name, just trunacate the whole name
                return filename.substring(0, MAX_FILENAME_LENGTH)
            }
        }

        return filename
    }

    const [docs, setDocs] = useState({formsAgreements: [], noticesLetters: [] });
    
    useEffect(() => {
        const formsAgreements = []
        const noticesLetters = []
        const suretyBondDocs = []
        licenceApplication.documents?.forEach((document) => {
            if(document.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS) {
                formsAgreements.push(document)
            } else if(document.documentType === DOCUMENT_TYPE_NOTICES_LETTERS) {
                noticesLetters.push(document)
            } else if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
                suretyBondDocs.push(document);
            }
        })
        setDocs({formsAgreements, noticesLetters, suretyBondDocs})
    }, [licenceApplication])

    const onFormsFileInputChange = (e) => {
        if (e.target.files.length > 0) {
            let file = e.target.files[0]

            // individual file size can not be more than 15 MB
            if (file.size > (individualFileSizeAllowedInMB * (2 ** 20))) {
                alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE, individualFileSizeAllowedInMB))
                return
            } else if (!validateFileName(file.name)) {
                alert("File name is not valid. Please select another file.")
                return
            }

            let reader = new FileReader()
            reader.onload = (readerData) => {
                setFormsFile({
                    filename: fileNameWithLengthLimit(file.name),
                    documentContentType: fileTypeEnum(file.type),
                    data: extractBase64(readerData.target.result),
                    changeType: "SAVE",
                    documentType: "FORMS_AGREEMENT",
                    fileSize: file.size
                })
            }
            reader.readAsDataURL(file)
        }
    }

    const handleUpload = () => {
        // save and push to next

        const {formsAgreements, noticesLetters, suretyBondDocs} = docs
        
        // dispatch(setAgencySupportingDocuments({
        //     formsAgreements: documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS ? [...formsAgreements, formsFile] : formsAgreements,
        //     noticesLetters: documentType === DOCUMENT_TYPE_NOTICES_LETTERS ? [...noticesLetters, formsFile] : noticesLetters,
        //     suretyBondDocs
        // }))
        // console.log(docs)
        const newSupportingDocs = [...formsAgreements, ...noticesLetters, ...suretyBondDocs, formsFile]
        // console.log("UPLOADING", newSupportingDocs)
        dispatch(setAgencySupportingDocuments(newSupportingDocs))

        dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                // window.location.reload();
                // let nextUrl = window.location.href// supportingDocuments.navigation.next
                // if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
                //     && supportingDocuments.navigation.nextRenewal) {
                //     nextUrl = supportingDocuments.navigation.nextRenewal
                // }
                // dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
            })
            .catch(err => {
                // setApplicationSaveError(true)
            })
    }

    const handlDocumentTypeChange = (event) => {
        const value = event.target.value
        setDocumentType(value);
    }


    console.log(documentType)
    return (
        <>
            <div className="row">
                <div className="collector-licence-col col-md-4" style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
                    <span>Add document</span>
                </div>

                <div className="collector-licence-col col-md-8" style={{ display: "flex", flexGrow: 1, justifyContent: "space-around" }}>
                    <div style={{ flexGrow: 1 }}>
                        <fieldset className="ns-fieldset">
                            <div className={"ns-fieldset" + (!isFormsValid() ? " ns-fieldset-message-error" : "")}>
                                <label
                                    id="supporting-document-notices-file-label"
                                    className="ns-label"
                                    htmlFor="supporting-document-notices-file-input">
                                    Upload a file
                            </label>
                                {!isFormsValid() && <div className="ns-error-message form-validation-error topMarginNormal">
                                    {ErrorWithString(ERROR_STRING.SUPPORTING_DOC_MISSING_NOTICE)}
                                </div>}
                                <div className="ns-file-input" style={{ display: "flex", flexDirection: "column" }}>
                                    <input
                                        // style={{ width: "15em", display: "inline" }}
                                        type="file"
                                        className="ns-input"
                                        id="supporting-document-notices-file-input"
                                        name="supporting-document-notices-file-input"
                                        accept={acceptedFileFormats(DOCUMENT_TYPE_FORMS_AGREEMENTS).join(',')}
                                        multiple={false}
                                        value={formsFile?.fileName}
                                        onInput={onFormsFileInputChange} />
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div>
                        <Button className="btn btn-primary" style={{ padding: "0.75em 2em" }} onClick={handleUpload} text="Upload" />
                    </div>

                </div>

            </div>
            <div className="row">
                <div className="collector-licence-col col-md-8">
                    <fieldset className="ns-fieldset">
                        <div className={"ns-radios ns-radios--small"}>
                            <div className="ns-radios__item">
                                <input
                                    className="ns-radios__input"
                                    type={"radio"}
                                    value={DOCUMENT_TYPE_FORMS_AGREEMENTS}
                                    checked={documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS}
                                    onChange={handlDocumentTypeChange}
                                    id={"bltinformation-document-type-input"}
                                    name={"bltinformation-document-type-input"}
                                />
                                <label
                                    id={"bltinformation-document-type-label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltinformation-document-type-input"}>
                                    <span className="bltReviewDecisionInfo">Forms Agreements</span>
                                </label>
                            </div>

                            <div className="ns-radios__item">
                                <input
                                    className="ns-radios__input"
                                    type={"radio"}
                                    value={DOCUMENT_TYPE_NOTICES_LETTERS}
                                    checked={documentType === DOCUMENT_TYPE_NOTICES_LETTERS}
                                    onChange={handlDocumentTypeChange}
                                    id={"bltinformation-document-type-input"}
                                    name={"bltinformation-document-type-input"}
                                />
                                <label
                                    id={"bltreview-decision-form-approve-label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltinformation-document-type-input"}>
                                    <span className="bltReviewDecisionInfo">Notices Letters</span>
                                </label>
                            </div>



                        </div>
                    </fieldset>
                </div>
            </div>

            <LineSeperator />
        </>
    )
}